import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleReadSpeakerVisibilityComponent } from './toggle-read-speaker-visibility.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WordingModule } from '../../../pipes';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatTooltipModule, WordingModule, ToggleReadSpeakerVisibilityComponent],
  exports: [ToggleReadSpeakerVisibilityComponent],
})
export class ToggleReadSpeakerVisibilityModule {}
